import Vue from 'vue'

const Events = new Vue({})
export default Events
